import * as Yup from 'yup';
import { is_email_unique } from '../../services/account';
import debounce from 'lodash.debounce';
import { emailRegExp } from '../../constants/validation_expressions';

function addSuperAdminValidation() {
  const schema = Yup.object().shape({
    first_name: Yup.string().required('First  Name is required'),
    last_name: Yup.string().required('Last Name is required'),
    email: Yup.string().required('Email is required')
      .matches(emailRegExp, 'Email is not valid')
      .test('unique_email', 'Email address must be unique', async (emailAddress) => {
        if (emailAddress) {
          const response = await debouncedApiEmailAddress(emailAddress);
          if (!response) return true;
          return response?.data?.data?.unique;
        }
      }),
    // contactNumber: Yup.string().required('Contact is required'),
  });
  return schema;
}

const debouncedApiEmailAddress = debounce(is_email_unique, 500);

export { addSuperAdminValidation };
